import React, {ReactNode} from 'react';
import ModalWithPopover from "@ui/modalWithPopover/ModalWithPopover";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import {useTranslation} from 'react-i18next';
import {ITaskSingleVoyage} from "@containers/singleVoyage/tasks/types";
import TaskActionsPanelSingleVoyage
    from "@containers/singleVoyage/tasks/taskActions/TaskActionsPanelSingleVoyage";
import {sx} from './sx';

interface IProps {
    task: ITaskSingleVoyage
    accountId: string | number
    voyageId?: number
    canCloseTask?: boolean
    extra?: ReactNode
    small?: boolean
    /** Told when the panel opens, so the row can mark itself as the one being acted on. */
    onOpenChange?: (open: boolean) => void
}

/**
 * The whole-task close, behind one press.
 *
 * A double tick, not three dots: the row next to it already closes this stop
 * with a single tick, so the icon reads as the same thing everywhere instead of
 * making you open a menu to find out what is inside it.
 */
const TaskActionsModalSingleVoyage = ({
                                          task,
                                          accountId,
                                          voyageId,
                                          canCloseTask,
                                          extra,
                                          small,
                                          onOpenChange,
                                      }: IProps) => {

    const {t} = useTranslation()

    return (
        <ModalWithPopover
            label={t('singleVoyage.closeTaskFully')}
            onOpenChange={onOpenChange}
            component={<TaskActionsPanelSingleVoyage
                task={task}
                accountId={accountId}
                voyageId={voyageId}
                canCloseTask={canCloseTask}
                extra={extra}
            />}
            button={<IconButtonCustom
                tooltip={t('singleVoyage.closeTaskFully')}
                size={'small'}
                variant={'empty'}
                sx={sx.trigger}
            >
                <DoneAllIcon sx={small ? {width: '15px', height: '15px'} : undefined}/>
            </IconButtonCustom>}
        />
    );
};

export default TaskActionsModalSingleVoyage;
